import React from 'react';
import IconTooltipModal from '../../components/ui/IconTooltipModal';
import SvgIcon from '../../utils/SvgIcon';

type AttachmentsModalProps = Readonly<{
  row: Record<string, unknown>;
  listingType: string;
}>;

export default function AttachmentsModal({ row }: AttachmentsModalProps) {
  if (!row.isAvailableWasteTransferNote && !row.isAvailableWeighbridgeTicket) {
    return null;
  }

  return (
    <IconTooltipModal
      tooltip="Open documents"
      triggerAriaLabel="Open documents"
      triggerIcon={
        <SvgIcon iconName="attachment" additionalClasses="tooltip-icon-trigger-attachments-icon" viewBox="0 0 24 24" />
      }
      modalTitle="Documents"
      modalClassName="modal--portal-docs"
      dialogClassName="modal__content--portal-docs"
      closeAriaLabel="Close"
    >
      <ul className="modal-docs__list">
        {row.isAvailableWeighbridgeTicket ? (
          <li className="modal-docs__item">
            <a
              className="modal-docs__link"
              href={`/api/downloads/weighbridgeticket/${row.guid}`}
              target="_blank"
              rel="noreferrer noopener"
              title="Download weighbridge ticket"
            >
              <span className="modal-docs__link-text">Weighbridge</span>
              <span aria-hidden className="modal-docs__icon">
                <SvgIcon iconName="open-new-window" viewBox="0 0 24 24" />
              </span>
            </a>
          </li>
        ) : null}
        {row.isAvailableWasteTransferNote ? (
          <li className="modal-docs__item">
            <a
              className="modal-docs__link"
              href={`/api/downloads/wastetransfernote/${row.guid}`}
              target="_blank"
              rel="noreferrer noopener"
              title="Download waste transfer note"
            >
              <span className="modal-docs__link-text">Transfer note</span>
              <span aria-hidden className="modal-docs__icon">
                <SvgIcon iconName="open-new-window" viewBox="0 0 24 24" />
              </span>
            </a>
          </li>
        ) : null}
      </ul>
    </IconTooltipModal>
  );
}
